<template>
  <modal
    :is-hidden="isHidden"
    :is-open="isOpen"
    :title="$t('Common.languageSettings')"
    ref="modal"
    v-on:clickclose="closeDialog"
    :fixed="true"
  >
    <div v-for="locale in locales" class="pad-15 locales">
      <button type="button" :class="['btn', 'btn-sm', 'fullw', {'btn-default': locale != currentLocale, 'active': locale == currentLocale}]" v-on:click="changeLocale(locale)">
        <img :src="icon(locale)" />
        {{ $t('Lang.' + locale) }}
      </button>
    </div>

    <template slot="footer">
      <button type="button" class="btn btn-sm btn-primary" :disabled="activeRequest" v-on:click="closeDialog">{{ $t('Action.close') }}</button>
    </template>
  </modal>
</template>

<script>
var view = require('../view.js'),
    viewData = {
      isHidden: true,
      isOpen: false,
      currentLocale: null,
      activeRequest: null,
    };

export default view(viewData, {
  props: {
    imgPath: {
      type: String
    }
  },
  computed: {
    locales() {
      return Object.keys(this.$i18n.messages);
    }
  },
  // mounted() {},
  methods: {
    closeDialog() {
      if (!this.activeRequest) {
        this.$refs.modal.close(this);
      }
    },
    openDialog(description) {
      this.currentLocale = this.$i18n.locale;
      this.$refs.modal.open(this);
    },
    changeLocale(locale) {
      this.closeDialog();
      this.$parent.applyLanguage(locale);
    },
    icon(locale) {
      return `/img/flags/${locale}.png`;
    }
  }
});
</script>
